// extracted by mini-css-extract-plugin
export default {"like":"_1YyTJ","not-clickable":"_21cw-","notClickable":"_21cw-","likebutton":"bfEYk","likes":"_1J07L"};